import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {AiOutlineClose} from 'react-icons/ai';

let CancelarAPEButton = (props) => {
    return (
        <Tooltip title="Cancelar APE">
            <IconButton
                style={{ color: '#922D50' }}
                aria-label="cancel"
                disabled={props.disabled}
                onClick={() => props.onClick()}
            >
                <AiOutlineClose />
            </IconButton>
        </Tooltip>
    );
}

export default CancelarAPEButton;

  

